// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Toast_wrap__rtzZv","toast":"Toast_toast__qfvBS","visible":"Toast_visible__SV2H0","dot":"Toast_dot__ELVqY"};